// extracted by mini-css-extract-plugin
export default {"tab":"TabNav_tab__NkiBR"};